"use strict";

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");
/* eslint-disable */


var react_1 = require("react");

var useEffectOnce_1 = tslib_1.__importDefault(require("./useEffectOnce"));

function createGlobalState(initialState) {
  var store = {
    state: initialState,
    setState: function setState(state) {
      store.state = state;
      store.setters.forEach(function (setter) {
        return setter(store.state);
      });
    },
    setters: []
  };
  return function () {
    var _a = react_1.useState(store.state),
        globalState = _a[0],
        stateSetter = _a[1];

    useEffectOnce_1["default"](function () {
      return function () {
        store.setters = store.setters.filter(function (setter) {
          return setter !== stateSetter;
        });
      };
    });
    react_1.useLayoutEffect(function () {
      if (!store.setters.includes(stateSetter)) {
        store.setters.push(stateSetter);
      }
    });
    return [globalState, store.setState];
  };
}

exports.createGlobalState = createGlobalState;
exports["default"] = createGlobalState;